import React from "react";
import { Globe, Star, Mail, Phone, MapPin, User, Ban } from "lucide-react";

export default function ResultsTable({ results, selected, toggle, toggleAll, onBlock }) {
  const allSelected = results.length > 0 && results.every((r) => selected[r.id]);

  return (
    <div className="bg-white rounded-2xl border border-border overflow-hidden">
      <div className="overflow-x-auto no-scrollbar">
        <table className="w-full text-[13px] min-w-[860px]">
          <thead>
            <tr className="text-left text-muted-foreground border-b border-border bg-secondary/50">
              <th className="py-3 px-4 w-10">
                <input type="checkbox" checked={allSelected} onChange={toggleAll}
                  className="w-4 h-4 accent-brand-600 cursor-pointer" />
              </th>
              <th className="py-3 px-3 font-medium">Company</th>
              <th className="py-3 px-3 font-medium">Address</th>
              <th className="py-3 px-3 font-medium">Phone</th>
              <th className="py-3 px-3 font-medium">Email</th>
              <th className="py-3 px-3 font-medium text-center">Rating</th>
              <th className="py-3 px-3 font-medium text-center">Site</th>
              {onBlock && <th className="py-3 px-3 font-medium text-center">Block</th>}
            </tr>
          </thead>
          <tbody>
            {results.map((r) => (
              <tr key={r.id} className={`border-b border-border/60 transition-colors ${selected[r.id] ? "bg-brand-50/50" : "hover:bg-secondary/30"}`}>
                <td className="py-3 px-4">
                  <input type="checkbox" checked={!!selected[r.id]} onChange={() => toggle(r.id)}
                    className="w-4 h-4 accent-brand-600 cursor-pointer" />
                </td>
                <td className="py-3 px-3 font-medium text-foreground">
                  {r.name}
                  {r.first_name && (
                    <span className="ml-2 inline-flex items-center gap-0.5 text-[11px] font-normal text-brand-600 bg-brand-50 px-1.5 py-0.5 rounded">
                      <User size={10} /> {r.first_name}
                    </span>
                  )}
                </td>
                <td className="py-3 px-3 text-muted-foreground">
                  <span className="inline-flex items-start gap-1"><MapPin size={13} className="mt-0.5 shrink-0 text-muted-foreground/70" />{r.address}</span>
                </td>
                <td className="py-3 px-3 text-foreground">
                  {r.phone ? <a href={`tel:${r.phone}`} className="inline-flex items-center gap-1 hover:text-brand-600"><Phone size={12} />{r.phone}</a> : <span className="text-muted-foreground/50">—</span>}
                </td>
                <td className="py-3 px-3">
                  {r.email ? (
                    <a href={`mailto:${r.email}`} className="inline-flex items-center gap-1 text-brand-600 hover:underline"><Mail size={12} />{r.email}</a>
                  ) : (
                    <span className="text-[11px] text-muted-foreground/60 bg-secondary px-2 py-0.5 rounded">no email</span>
                  )}
                </td>
                <td className="py-3 px-3 text-center">
                  {r.rating ? (
                    <span className="inline-flex items-center gap-1 text-foreground"><Star size={12} className="text-amber-500 fill-amber-500" />{r.rating} <span className="text-muted-foreground/60">({r.reviews})</span></span>
                  ) : <span className="text-muted-foreground/50">—</span>}
                </td>
                <td className="py-3 px-3 text-center">
                  {r.website ? (
                    <a href={r.website} target="_blank" rel="noreferrer" className="inline-flex text-muted-foreground hover:text-brand-600"><Globe size={15} /></a>
                  ) : <span className="text-muted-foreground/40">—</span>}
                </td>
                {onBlock && (
                  <td className="py-3 px-3 text-center">
                    <button onClick={() => onBlock(r)} title="Add to Do-Not-Contact"
                      className="inline-flex text-muted-foreground/50 hover:text-red-500 transition-colors"><Ban size={15} /></button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
